module.exports = __webpack_public_path__ + "img/howitworks-3-lp.0eaaf7a.svg";